<!-- <div class="cctv-camera">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="">
                    <h4 class="cctv-title">Add DVR Details</h4>
                </div>
            </div>
        </div>
    </div>
</div> -->

<!--================ search bar ===================-->

<section class="mis_dropdown">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="searchwidth">
                    <div class="input-group">
                        <input type="text" class="form-control misinput_control" placeholder="Enter Building Fusion Code"
                            (keydown)="onKeydown($event)"  [(ngModel)]="searchorg">
                        <div class="input-group-btn">
                            <button class="btn drop_iconsearch" type="submit" (click)="search(searchorg)">
                                <i class="fa fa-search" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12">
                <div class="search_mobshow">
                    <div>
                        <h6 class="mob_searchhd">Search by</h6>
                    </div>
                    <div class="searchitem_scroll">
                        <ul class="search_items">
                            <li><a href="#">Admission no </a></li>
                            <li><a href="#">School</a></li>
                            <li><a href="#">State</a></li>
                            <li><a href="#">Zone</a></li>
                            <li><a href="#">City</a></li>
                            <li><a href="#">Campus</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!--================  search bar end ================-->
<section>
    <div class="container">
        <div class="row">

        </div>
    </div>
</section>

<!-- <div class="cctv-camera">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="">
                    <h4 class="cctv-title">DVR/NVR List</h4>
                </div>
            </div>
        </div>
    </div>
</div> -->

<!-- <section>
    <div class="container">
        <div class="row">
            <div class="cctvcouncelling__sec1">
                <div class="councellist__flex">
                    <div class="campus-det">
                        <div>
                            <img src="../../assets/image/dvr-image.svg" alt="dvr-images" class="dvr-images">
                        </div>
                        <div class="dvr-campus">
                            <h4 class="campus-names">Boys Building-Alwal</h4>
                        </div>
                        <div>
                            <h4 class="campus-date">12-03-2024 11:18</h4>
                        </div>

                    </div>
                    <table class="table-dvr">
                        <tr>
                            <td>8/13</td>
                            <td>IP</td>
                            <td>HTTP</td>
                            <td class="campus-arrow"><i class="fa-solid fa-greater-than"></i></td>
                        </tr>
                        <tr >
                            <td class="dvr-numbers">DVR 480</td>
                            <td>175.101.39.12</td>
                            <td>8000</td>
                            <td class="view-all">View All</td>
                        </tr>
                    </table>
                </div>

                <div class="councellist__flex">
                    <div class="campus-det">
                        <div>
                            <img src="../../assets/image/dvr-image.svg" alt="dvr-images" class="dvr-images">
                        </div>
                        <div class="dvr-campus">
                            <h4 class="campus-names">Boys Building-Alwal</h4>
                        </div>
                        <div>
                            <h4 class="campus-date">12-03-2024 11:18</h4>
                        </div>

                    </div>
                    <table class="table-dvr">
                        <tr>
                            <td>8/13</td>
                            <td>IP</td>
                            <td>HTTP</td>
                            <td class="campus-arrow"><i class="fa-solid fa-greater-than"></i></td>
                        </tr>
                        <tr >
                            <td class="dvr-numbers">DVR 480</td>
                            <td>175.101.39.12</td>
                            <td>8000</td>
                            <td class="view-all">View All</td>
                        </tr>
                    </table>
                </div>

                <div class="councellist__flex">
                    <div class="campus-det">
                        <div>
                            <img src="../../assets/image/dvr-image.svg" alt="dvr-images" class="dvr-images">
                        </div>
                        <div class="dvr-campus">
                            <h4 class="campus-names">Boys Building-Alwal</h4>
                        </div>
                        <div>
                            <h4 class="campus-date">12-03-2024 11:18</h4>
                        </div>

                    </div>
                    <table class="table-dvr">
                        <tr>
                            <td>8/13</td>
                            <td>IP</td>
                            <td>HTTP</td>
                            <td class="campus-arrow"><i class="fa-solid fa-greater-than"></i></td>
                        </tr>
                        <tr >
                            <td class="dvr-numbers">DVR 480</td>
                            <td>175.101.39.12</td>
                            <td>8000</td>
                            <td class="view-all">View All</td>
                        </tr>
                    </table>
                </div>

                <div class="councellist__flex">
                    <div class="campus-det">
                        <div>
                            <img src="../../assets/image/dvr-image.svg" alt="dvr-images" class="dvr-images">
                        </div>
                        <div class="dvr-campus">
                            <h4 class="campus-names">Boys Building-Alwal</h4>
                        </div>
                        <div>
                            <h4 class="campus-date">12-03-2024 11:18</h4>
                        </div>

                    </div>
                    <table class="table-dvr">
                        <tr>
                            <td>8/13</td>
                            <td>IP</td>
                            <td>HTTP</td>
                            <td class="campus-arrow"><i class="fa-solid fa-greater-than"></i></td>
                        </tr>
                        <tr >
                            <td class="dvr-numbers">DVR 480</td>
                            <td>175.101.39.12</td>
                            <td>8000</td>
                            <td class="view-all">View All</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</section> -->

<!-- data table -->


<section class="section_one">
    <div class="container">
        <div class="row">
            <ng-container *ngFor="let data of oracledata">
                <div class="cctvcouncelling__sec">
                    <div class="councellist__flex">
                        <div class="campus_list">
                            <!-- <img src="../../assets/image/dvr-image.svg" alt="dvr-image" class="dvr-image"> -->
                            <div class="building_Name">
                                <span>Campus Name :</span>
                                <span class="campus-name">{{data.campusName}}</span>
                            </div>
                            <div class="building_Name">
                                <span>Building Name :</span>
                                <span class="buildingname">{{data.buildingName}}</span>
                            </div>
                            <div class="icon_flex add-dvr-icon-flex">
                                <button type="button" class="dvr-view" (click)="opendvr()">Add DVR</button>
                            </div>
                        </div>
                        <div class="building_Address">
                            <span>Building Address :</span>
                            <span class="building-address">{{data.buildingAddress}}</span>
                        </div>
                    </div>
                </div>

                <div class="col-md-12">
                    <div class="ibox">
                        <!-- <div class="ibox-title report_flexweb">
                            <div>
                                <h5>DVR/NVR List</h5>
                            </div>
                            <div class="icon_flex add-dvr-icon-flex">
                                <button type="button" class="dvr-view" (click)="opendvr()">Add DVR</button>
                            </div>
                        </div> -->
                        <div class="ibox-content">
                            <mat-card>
                                <!--- no data-->
                                <!-- <div class="searchpaginator">
                                    <div class="table_search">
                                        <input type="text" class="form-control" (keyup)="applyFilter($event)"
                                            placeholder="Search">
                                    </div>
                                    <div>
                                        <mat-paginator [pageSize]="10"
                                            [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
                                    </div>
                                </div> -->

                                <div class="table-responsive">
                                    <mat-card-content>
                                        <table mat-table [dataSource]="dataSource" matSort class="table_resize">
                                            <ng-container matColumnDef="buildingName">
                                                <th mat-header-cell *matHeaderCellDef  class="resizer"
                                                    appResizableColumns>Building Name
                                                </th>
                                                <td mat-cell *matCellDef="let element" style="text-align: left;">
                                                    {{element.buildingName}}
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="ipAddress">
                                                <th mat-header-cell *matHeaderCellDef 
                                                    appResizableColumns> IP Address
                                                </th>
                                                <td mat-cell *matCellDef="let element" style="text-align: left;">
                                                    {{element.ipAddress}} </td>
                                            </ng-container>
                                            <ng-container matColumnDef="rtspPortNo">
                                                <th mat-header-cell *matHeaderCellDef 
                                                    appResizableColumns> Rtsp Port No
                                                </th>
                                                <td mat-cell *matCellDef="let element" style="text-align: right;">
                                                    {{element.rtspPortNo}} </td>
                                            </ng-container>
                                            <ng-container matColumnDef="httpPortNo">
                                                <th mat-header-cell *matHeaderCellDef 
                                                    appResizableColumns> Server Port No
                                                </th>
                                                <td mat-cell *matCellDef="let element" style="text-align: right;">
                                                    {{element.httpPortNo}} </td>
                                            </ng-container>
                                            <ng-container matColumnDef="userName">
                                                <th mat-header-cell *matHeaderCellDef 
                                                    appResizableColumns> User Name
                                                </th>
                                                <td mat-cell *matCellDef="let element" style="text-align: left;">
                                                    {{element.userName}} </td>
                                            </ng-container>
                                            <ng-container matColumnDef="password">
                                                <th mat-header-cell *matHeaderCellDef 
                                                    appResizableColumns> password
                                                </th>
                                                <td mat-cell *matCellDef="let element" style="text-align: left;">
                                                    {{element.password}} </td>
                                            </ng-container>
                                            <ng-container matColumnDef="dvrModelNumber">
                                                <th mat-header-cell *matHeaderCellDef 
                                                    appResizableColumns> Model No & Serial No 
                                                </th>
                                                <td mat-cell *matCellDef="let element" style="text-align: left;">
                                                    {{element.dvrModelNumber}} </td>
                                            </ng-container>
                                            <!-- <ng-container matColumnDef="serialNumber">
                                                <th mat-header-cell *matHeaderCellDef 
                                                    appResizableColumns> Serial Number
                                                </th>
                                                <td mat-cell *matCellDef="let element" style="text-align: left;">
                                                    {{element.serialNumber}} </td>
                                            </ng-container> -->
                                            <ng-container matColumnDef="maxNoOfChannels">
                                                <th mat-header-cell *matHeaderCellDef 
                                                    appResizableColumns> Max No Of Channels
                                                </th>
                                                <td mat-cell *matCellDef="let element" style="text-align: right;">
                                                    {{element.maxNoOfChannels}} </td>
                                            </ng-container>
                                            <ng-container matColumnDef="totalCamerasInstalled">
                                                <th mat-header-cell *matHeaderCellDef 
                                                    appResizableColumns> Total Cameras Installed
                                                </th>
                                                <td mat-cell *matCellDef="let element" style="text-align: right;">
                                                    {{element.totalCamerasInstalled}} </td>
                                            </ng-container>
                                            <ng-container matColumnDef="totalWorkingCameras">
                                                <th mat-header-cell *matHeaderCellDef 
                                                    appResizableColumns> Total Working Cameras
                                                </th>
                                                <td mat-cell *matCellDef="let element" style="text-align: right;">
                                                    {{element.totalWorkingCameras}} </td>
                                            </ng-container>
                                            <ng-container matColumnDef="rtspAuthentication">
                                                <th mat-header-cell *matHeaderCellDef 
                                                    appResizableColumns> Rtsp Authentication
                                                </th>
                                                <td mat-cell *matCellDef="let element" style="text-align: left;">
                                                    {{element.rtspAuthentication}} </td>
                                            </ng-container>
                                            <ng-container matColumnDef="view">
                                                <th mat-header-cell *matHeaderCellDef> Edit </th>
                                                <td mat-cell *matCellDef="let element">
                                                    <button (click)="opendvrdetails(element)"
                                                        class="view_details">Edit</button>
                                                </td>
                                            </ng-container>
                                            <tr mat-header-row *matHeaderRowDef="displayedColumns  sticky: true">
                                            </tr>
                                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                                            <!-- Row shown when there is no matching data. -->
                                            <tr class="mat-row" *matNoDataRow>
                                                <td class="mat-cell" class="not_matchdata" colspan="13">No data matching the filter
                                                </td>
                                            </tr>
                                        </table>
                                    </mat-card-content>
                                    <!-- <table class="table table-bordered table-striped dataTables-example cctv_datatable"
                                    id="example">
                                    <thead>
                                        <tr>
                                            <th style="width: 119.688px;">Name</th>
                                            <th style="width: 99.5375px;">IP Address</th>
                                            <th>RTSP Port</th>
                                            <th>HTTP Port</th>
                                            <th>User Name</th>
                                            <th>Password</th>
                                            <th style="width: 60.0375px;">Model No</th>
                                            <th style="width: 251.15px;">Serial No</th>
                                            <th>Max no of Channels</th>
                                            <th style="width: 84.8125px !important;">Total Cameras Installed</th>
                                            <th style="width: 49.5375px;">Total Working Cameras</th>
                                            <th style="width: 73.15px !important;">RTSP Authentication</th>
                                            <th style="width: 38px;">View</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let dvr of dvrlistdetails"
                                            style="font-family:montserrat,sans-serif;">
                                            <td>{{dvr.buildingName}}</td>
                                            <td>{{dvr.ipAddress}}</td>
                                            <td>{{dvr.rtspPortNo}}</td>
                                            <td>{{dvr.httpPortNo}}</td>
                                            <td>{{dvr.userName}}</td>
                                            <td>{{dvr.password}}</td>
                                            <td>{{dvr.dvrModelNumber}}</td>
                                            <td>{{dvr.serialNumber}}</td>
                                            <td>{{dvr.maxNoOfChannels}}</td>
                                            <td>{{dvr.totalCamerasInstalled}}</td>
                                            <td><span class="working_txt">{{dvr.totalWorkingCameras}}</span></td>
                                            <td><span class="notworking_txt"></span>{{dvr.rtspAuthentication}}</td>
                                            <td><button type="button" class="cctv_btnview"
                                                    (click)="opendvrdetails(dvr)">view</button></td>
                                        </tr>
                                    </tbody>
                                </table> -->
                                </div>
                            </mat-card>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</section>


<!-- =======Loading ========== -->

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>